import React, { useState, useEffect } from "react";
import DashboardLayout from "../components/DashboardLayout";

// Puedes editar este array para agregar/quitar links de Google Drive
const linksDeDescarga = [
  {
    nombre: "PwC",
    url: "https://drive.google.com/drive/folders/1aKy1hhW6RI9ZKII1kQPiDiiRW46g81es?usp=drive_link",
  },
  {
    nombre: "Presentación",
    url: "https://drive.google.com/drive/folders/1GNDsVj-xkeWH5w7bivvP7C_gk5j46NJ3?usp=drive_link",
  },
];

export default function Dashboard() {
  const [username, setUsername] = useState("");

  useEffect(() => {
    // Recuperamos el nombre del usuario guardado en localStorage
    const storedUsername = localStorage.getItem("username");
    setUsername(storedUsername || "");
  }, []);

  // const handleLogout = () => {
  //   localStorage.removeItem("jwt");
  //   localStorage.removeItem("username");
  //   window.location.href = "https://web.institucional.global.sidom.io/";
  // };

  return (
    <DashboardLayout user={username}>
      <div className="mb-8 flex justify-between items-center"></div>

      {/* Formulario de HubSpot */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-white">
          Formulario de HubSpot
        </h2>
        <div className="bg-white dark:bg-gray-900 p-4 rounded shadow">
          <p className="text-gray-500">[Aquí va el formulario de HubSpot]</p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-white">
          Descargas
        </h2>
        <ul className="list-disc pl-5">
          {linksDeDescarga.map((link, idx) => (
            <li key={idx} className="mb-2">
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                {link.nombre}
              </a>
            </li>
          ))}
        </ul>
      </section>
    </DashboardLayout>
  );
}
